import { MerchantGeneralSettingsResponse } from 'APIs/merchants/merchants.types';
import Spinner from 'Components/Spinner/Spinner';
import { H2, Label, LpBox, LpDetails, Row } from 'Constants/styles';
import { MouseEvent, ReactElement } from 'react';
import { divideBy100, formatAmount } from 'utils/currency';

import { EditBtn, PayLimitAmount, SpinnerWrapper } from '../../MerchantDetails/styles';
import UpdateCheckoutLimitsModal from './UpdateCheckoutLimitsModal';
import { UpdateCheckoutLimitsFormProps, toUpdateCheckoutLimitsFormProps } from './types';

type Props = {
  generalSettings: MerchantGeneralSettingsResponse | null;
  isLoading: boolean;
  isModalLoading: boolean;
  modalError: string;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  updateCheckoutLimitsHandler: (formData: UpdateCheckoutLimitsFormProps) => void;
};

const CheckoutLimitsData = ({
  generalSettings,
  isLoading,
  isModalLoading,
  modalError,
  showModal,
  setShowModal,
  updateCheckoutLimitsHandler,
}: Props): ReactElement => {
  const handleEditClick = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setShowModal(true);
  };

  return (
    <LpBox>
      <Row>
        <div className="col-sm-7">
          <H2 className="mb-0">Pay in full limits</H2>
        </div>
        <div className="col-sm-5 text-right">
          <EditBtn onClick={handleEditClick}>Edit limits</EditBtn>
        </div>
      </Row>
      {isLoading && (
        <SpinnerWrapper>
          <Spinner color="#0016D1" />
        </SpinnerWrapper>
      )}
      {!isLoading && generalSettings && (
        <LpDetails>
          <Row className="pt-4">
            <div className="col-sm-4">
              <Label>Minimum amount</Label>
            </div>
            <PayLimitAmount className="col-sm-8">
              {generalSettings.payInFullMinCheckoutLimit
                ? formatAmount(divideBy100(generalSettings.payInFullMinCheckoutLimit), { useGrouping: true })
                : 'System Default'}
            </PayLimitAmount>
          </Row>
          <Row className="pt-4">
            <div className="col-sm-4">
              <Label>Maximum amount</Label>
            </div>
            <PayLimitAmount className="col-sm-8">
              {generalSettings.payInFullMaxCheckoutLimit
                ? formatAmount(divideBy100(generalSettings.payInFullMaxCheckoutLimit), { useGrouping: true })
                : 'System Default'}
            </PayLimitAmount>
          </Row>
        </LpDetails>
      )}
      {showModal && generalSettings && (
        <UpdateCheckoutLimitsModal
          updateCheckoutLimitsFormProps={toUpdateCheckoutLimitsFormProps(generalSettings)}
          isModalLoading={isModalLoading}
          modalErrorMsg={modalError}
          updateCheckoutLimitsHandler={updateCheckoutLimitsHandler}
          setShowModal={setShowModal}
        />
      )}
    </LpBox>
  );
};

export default CheckoutLimitsData;
